import type { MapLayer } from "./mapLayer";

/**
 * Zoomed far out the viewport bbox is huge, so WFS feature queries and tile fetches get large
 * and slow while the data is barely legible. A layer's `minZoom` stops it fetching and drawing
 * strictly below that zoom, matching Mapbox `minzoom` semantics.
 */
export const DEFAULT_LAYER_MIN_ZOOM = 14;

/** Never below the default layer threshold, so layers draw in the initial view. */
export const DEFAULT_MAP_ZOOM = Math.max(15, DEFAULT_LAYER_MIN_ZOOM);

export function isBelowMinZoom(layer: MapLayer, zoom: number): boolean {
  return zoom < layer.minZoom;
}
